export default function CameraZoomControl({ visible, range, value, onChange }) {
  if (!visible || !range) return null;

  return <label className="plate-camera__zoom">
    <span>بزرگ‌نمایی</span>
    <input type="range" min={range.min} max={range.max} step={range.step} value={value} onChange={event => onChange(event.target.value)} aria-label="بزرگ‌نمایی دوربین" />
  </label>;
}
